/**
 * Determines if the current route is an admin route
 * @param pathname - The current pathname
 * @returns boolean indicating if it's an admin route
 */
export const isAdminRoute = (pathname: string): boolean => {
  return pathname.startsWith('/admin/');
};

/**
 * Determines if the current route is an employee route
 * @param pathname - The current pathname
 * @returns boolean indicating if it's an employee route
 */
export const isEmployeeRoute = (pathname: string): boolean => {
  return pathname.startsWith('/employee/');
};

/**
 * Determines the appropriate view mode based on the current route
 * @param pathname - The current pathname
 * @param isAdmin - Whether the user is an admin
 * @returns boolean indicating if admin view should be active
 */
export const getViewModeFromRoute = (
  pathname: string,
  isAdmin: boolean,
): boolean => {
  // If user is not an admin, always use employee view
  if (!isAdmin) {
    return false;
  }

  // If user is admin, check the route
  if (isAdminRoute(pathname)) {
    return true; // Admin view for admin routes
  } else if (isEmployeeRoute(pathname)) {
    return false; // Employee view for employee routes
  }

  // Default to admin view for admins on other routes
  return true;
};
